import { proxy } from 'src/core/classes/helpers/UrlHelper'

export const fetchSearch = async (id: number, dataSet: string, payload: object) => {
  const formData = new FormData()
  for (const [key, value] of Object.entries(payload)) {
    formData.append(key, value instanceof Object ? JSON.stringify(value) : value)
  }

  try {
    const response = await fetch(
      proxy(`/form/data-set-provider/v3/${id}/${dataSet}/kendo/data/search`),
      {
        method: 'POST',
        body: formData,
      }
    )
    const responseJson = await response.json()
    return { items: responseJson.Data }
  } catch (e: unknown) {
    console.error(e)
  }

  return { items: [] }
}

export const fetchSurvey = async (id: number, dataSet: string, userId: string) => {
  if (!userId) {
    return { items: [] }
  }

  try {
    const response = await fetch(
      proxy(`/form/data-set-provider/v3/${id}/${dataSet}/data/userId/${userId}`),
      {
        method: 'GET',
      }
    )
    const responseJson = await response.json()
    return { items: responseJson.Data }
  } catch (e: unknown) {
    console.error(e)
  }

  return { items: [] }
}
